import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '.'
import { Phenomene } from '@/orrm/model/phenomene'
import { Departement } from '@/orrm/model/departement'
import Fetcher from '@/utils/fetcher'
import { EntityType } from '@/orrm/model/entity-type'
import { InfoBundle } from '@/orrm/model/info-bundle'

const _namespace = 'storage'

@Module({ dynamic: true, store, namespaced: true, name: _namespace })
export default class StorageModule extends VuexModule {
  phenomenes: Phenomene[] = []
  departements: Departement[] = []
  entityTypes: EntityType[] = []
  infoBundles: InfoBundle[] = []

  loadingPhenomenes = false
  loadingDepartements = false
  loadingEntityTypes = false
  loadingInfoBundles = false

  phenomenesLoaded = false
  departementsLoaded = false
  entityTypesLoaded = false
  infoBundlesLoaded = false

  get orderedEntityTypes (): EntityType[] {
    return this.entityTypes.sort((a: EntityType, b: EntityType) => {
      if (a.name === b.name) return 0
      return a.name > b.name ? 1 : -1
    })
  }

  @Mutation
  setPhenomenes (phenomenes: Phenomene[]) {
    this.phenomenes = phenomenes
  }

  @Mutation
  setDepartements (departements: Departement[]) {
    this.departements = departements
  }

  @Mutation
  setEntityTypes (entityTypes: EntityType[]) {
    this.entityTypes = entityTypes
  }

  @Mutation
  setInfoBundles (infoBundles: InfoBundle[]) {
    this.infoBundles = infoBundles
  }

  @Mutation
  setLoadingPhenomenes (loading: boolean) {
    this.loadingPhenomenes = loading
  }

  @Mutation
  setLoadingDepartements (loading: boolean) {
    this.loadingDepartements = loading
  }

  @Mutation
  setLoadingEntityTypes (loading: boolean) {
    this.loadingEntityTypes = loading
  }

  @Mutation
  setLoadingInfoBundles (loading: boolean) {
    this.loadingInfoBundles = loading
  }

  @Mutation
  setPhenomenesLoaded (loaded: boolean) {
    this.phenomenesLoaded = loaded
  }

  @Mutation
  setDepartementsLoaded (loaded: boolean) {
    this.departementsLoaded = loaded
  }

  @Mutation
  setEntityTypesLoaded (loaded: boolean) {
    this.entityTypesLoaded = loaded
  }

  @Mutation
  setInfoBundlesLoaded (loaded: boolean) {
    this.infoBundlesLoaded = loaded
  }

  @Action({ rawError: true })
  async initPhenomenes () {
    if (this.phenomenesLoaded) return
    const fetcher = new Fetcher(Phenomene.query())

    try {
      this.setLoadingPhenomenes(true)
      await fetcher.fetchAll()
      this.setPhenomenes(fetcher.datas as Phenomene[])
    } finally {
      this.setLoadingPhenomenes(false)
      this.setPhenomenesLoaded(true)
    }
  }

  @Action({ rawError: true })
  async initDepartements () {
    if (this.departementsLoaded) return
    const fetcher = new Fetcher(Departement.query())

    try {
      this.setLoadingDepartements(true)
      await fetcher.fetchAll()
      this.setDepartements(fetcher.datas as Departement[])
    } finally {
      this.setLoadingDepartements(false)
      this.setDepartementsLoaded(true)
    }
  }

  @Action({ rawError: true })
  async initEntityTypes () {
    if (this.entityTypesLoaded) return
    const fetcher = new Fetcher(EntityType.query())

    try {
      this.setLoadingEntityTypes(true)
      await fetcher.fetchAll()
      this.setEntityTypes(fetcher.datas as EntityType[])
    } finally {
      this.setLoadingEntityTypes(false)
      this.setEntityTypesLoaded(true)
    }
  }

  @Action({ rawError: true })
  async initInfoBundles () {
    if (this.infoBundlesLoaded) return
    const fetcher = new Fetcher(InfoBundle.query())

    try {
      this.setLoadingInfoBundles(true)
      await fetcher.fetchAll()
      this.setInfoBundles(fetcher.datas as InfoBundle[])
    } finally {
      this.setLoadingInfoBundles(false)
      this.setInfoBundlesLoaded(true)
    }
  }
}
